import { wasEmittedByJourney } from './activation';
import { JOURNEY_SIGNAL_DIMENSION } from '@cognitoforms/api/services/journey-envelope';

type ClickTelemetryItem = {
	data?: Record<string, unknown>;
};

/**
 * The `start:`/`step:` tag described by an auto-captured click event's content blob, if it has one.
 * The plugin strips the `data-cf-` prefix, so `data-cf-start` arrives as `start`.
 */
export function journeyTagFromContent(content: unknown): string | null {
	if (typeof content !== 'string')
		return null;

	let parsed: unknown;
	try {
		parsed = JSON.parse(content);
	}
	catch (e) {
		return null;
	}

	const blob = (Array.isArray(parsed) ? parsed[0] : parsed) as Record<string, unknown> | null;
	if (!blob || typeof blob !== 'object')
		return null;

	if (typeof blob.start === 'string' && blob.start)
		return `start:${blob.start}`;
	if (typeof blob.step === 'string' && blob.step)
		return `step:${blob.step}`;
	return null;
}

/**
 * Suppresses the Click Analytics plugin's copy of an activation the journey listener already reported.
 * Returns `false` to drop the item; anything else keeps it.
 */
export function filterDuplicateJourneyClick(item: ClickTelemetryItem): boolean {
	const data = item?.data;
	if (!data || data[JOURNEY_SIGNAL_DIMENSION])
		return true;

	const tag = journeyTagFromContent(data.content);
	return !(tag && wasEmittedByJourney(tag));
}
